import { ToLocaleDateTimeFromNowBaseValueConverter } from 'General/Resources/ValueConverters/ToLocaleDateTimeFromNowBase';
export class ToLocaleDateTimeFromNowValueConverter extends ToLocaleDateTimeFromNowBaseValueConverter {

}